module.exports = new __parcel__URL__("ferris-wheel.1f801a79.jpg").toString();